// extracted by mini-css-extract-plugin
export default {"nav-bar":"NavBar_nav-bar__Vzcta"};